export default "__VITE_ASSET__POFDoTig__"